// extracted by mini-css-extract-plugin
module.exports = {"root":"tabs_root__6nif6","list":"tabs_list__yyCX0","trigger":"tabs_trigger__SydvG"};